<div class="widget-tabs">
  @for (tab of tabs(); track tab.id) {
    <button
      type="button"
      class="tabs-button min-button-width"
      [class.selected]="tab.id === selected()"
      [class.tabs-with-icon]="tab.icon"
      (click)="tabsChange.emit(tab.id)"
    >
      @if (tab.icon) {
        <img width="20" height="20" priority [alt]="'app.imgAlt.moduleIcon' | translate" [ngSrc]="tab.icon" />
      }
      {{ tab.name | translate }}
      @if (tab.elementsNumber) {
        <span>({{ tab.elementsNumber }})</span>
      }
    </button>
  }
  <ng-content select="[end-content]" />
</div>
